export default [
  {
    path: '/multiproject',
    component: () => import('src/layouts/DefaultLayout'),
    meta: { requiresAuth: true },
    children: [
      {
        path: '',
        name: 'MultiprojectMain',
        component: () => import('./containers/MultiprojectContainer'),
        children: [
          {
            path: 'draws',
            name: 'MultiprojectDrawList',
            component: () => import('./containers/DrawListContainer'),
            children: [
              {
                path: 'create',
                name: 'MultiprojectDrawCreate',
                component: () => import('./containers/DrawCreateContainer'),
              },
              {
                path: ':drawId',
                name: 'MultiprojectDrawUpdate',
                props: true,
                component: () => import('./containers/DrawUpdateContainer'),
              },
            ],
          },
          {
            path: 'versions',
            name: 'MultiprojectVersionList',
            component: () => import('./containers/VersionListContainer'),
            children: [
              {
                path: 'create',
                name: 'MultiprojectVersionCreate',
                component: () => import('./containers/VersionCreateContainer'),
              },
              {
                path: ':versionId',
                name: 'MultiprojectVersionUpdate',
                props: true,
                component: () => import('./containers/VersionUpdateContainer'),
              },
            ],
          },
        ],
      },
    ],
  },
]
